"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateFnsLocale = exports.getLanguage = exports.SUPPORTED_LANGUAGES = void 0;
const locale_1 = require("date-fns/locale");
const localized_strings_1 = __importDefault(require("localized-strings"));
// A lot of tests use String.prototype.toLocaleString which accepts
// a locale as first parameter. If it's passed undefined, it will
// try to automatically detect the user's language.
// Since tests run on an uncontrolled environment, we don't want
// to use automatic detection, and force the LOCALE to 'fr-FR'
// in the test environment
exports.SUPPORTED_LANGUAGES = { en: {}, fr: {} };
const locales = new localized_strings_1.default(exports.SUPPORTED_LANGUAGES);
const getLanguage = () => {
    const locale = (locales.getLanguage() || locales.getInterfaceLanguage()).substring(0, 2);
    return locale;
};
exports.getLanguage = getLanguage;
const LOCALE = (0, exports.getLanguage)();
const getDateFnsLocale = () => ((0, exports.getLanguage)() === 'fr' ? locale_1.fr : locale_1.enUS);
exports.getDateFnsLocale = getDateFnsLocale;
exports.default = LOCALE;
